<div *adaptLoading="!value"
     class="row avoid-page-break-inside">
    <div class="col-12 mb-3 mb-xl-0 col-xl d-flex align-items-center justify-content-center">
        <h2 class="mb-0 text-center text-center-print-inherit">
            {{ value!.name }}
        </h2>
    </div>
    <div class="col-12 col-xl-9 col-xxl-10">
        <div class="row g-3">
            <div class="col-12 col-lg-6 d-flex flex-column avoid-page-break-inside">
                <h4>Meaning</h4>
                <div class="value-content flex-grow-1">
                    @if (value!.meaning) {
                        <div [froalaView]="value!.meaning"></div>
                    } @else {
                        This value's meaning has not been defined.
                    }
                </div>
            </div>
            <div class="col-12 col-lg-6 d-flex flex-column avoid-page-break-inside">
                <ng-container *adaptIfFeatureFlagActive="OrganisationFeatureFlag.ValuesV2; else valuesV1">
                    <h4>Behaviours</h4>

                    <div class="value-content value-questions flex-grow-1">
                        @if (value!.valueQuestions.length > 0) {
                            <div class="d-flex flex-column gap-3">
                                @for (valueQuestion of value!.valueQuestions; track valueQuestion) {
                                    <div>
                                        <adapt-edit-behaviour [behaviour]="valueQuestion"
                                                              [readonly]="true"></adapt-edit-behaviour>
                                    </div>
                                }
                            </div>
                        } @else {
                            No behaviours have been defined.
                        }
                    </div>
                </ng-container>

                <ng-template #valuesV1>
                    <h4>Ask yourself</h4>

                    <div class="value-content value-questions flex-grow-1">
                        @if (value!.valueQuestions.length > 0) {
                            <ul>
                                <!-- TODO Handle ArrayChanged event in and order by ordinal -->
                                @for (valueQuestion of value!.valueQuestions; track valueQuestion) {
                                    <li [froalaView]="valueQuestion.question"></li>
                                }
                            </ul>
                        } @else {
                            No questions have been defined.
                        }
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>
